function ParentLayout({ children }) {
  return <div className="flex h-full min-h-0 px-2">{children}</div>;
}

export { ParentLayout };
